import React, { useEffect, useState } from 'react';
import { Input } from '../form/Input';
import { FormField } from '../form/FormField';
import { Label } from '../form/Label';

import { Checkbox, FormControlLabel, makeStyles, MenuItem, Select } from '@material-ui/core';
import { Diagnosis } from '../../model/Diagnosis';
import { useDispatch, useSelector } from 'react-redux';
import { selectUser } from '../../store/auth/auth.selector';
import { selectClinic, selectCustomDiagnosis, selectDescription, selectDiagnoses, selectFormInfo, selectUrgency } from '../../store/registration/registration.selector';
import { registrationActions } from '../../store/registration/registration.reducer';
import { RequestType } from '../../model/enums/RequestType';
import { Urgency } from '../../model/enums/Urgency';

const useStyles = makeStyles({
  subDiagnoses: {
    marginLeft: 40
  }
});

export const ProblemDescription = () => {
  const user = useSelector(selectUser);
  const dispatch = useDispatch();
  const classes = useStyles();
  const clinic = useSelector(selectClinic);
  const urgency = useSelector(selectUrgency);
  const urgencyOptions: Urgency[] = Object.values(Urgency);
  const selectedDiagnoses = useSelector(selectDiagnoses);
  const customDiagnosis = useSelector(selectCustomDiagnosis);
  const description = useSelector(selectDescription);

  const [showDiagnosisInput, setShowDiagnosisInput] = useState(customDiagnosis.length > 0);

  useEffect(() => {
    if (!showDiagnosisInput) {
      dispatch(registrationActions.setCustomDiagnosis(''));
    }
  }, [showDiagnosisInput, dispatch]);

  const handleDiagnosisToggle = (diagnosis: Diagnosis) => {
    let diagnoses = [...selectedDiagnoses];
    const index = diagnoses.indexOf(diagnosis.name);

    if (index === -1) {
      // Add diagnosis
      diagnoses = [
        ...diagnoses,
        diagnosis.name
      ];
    } else {
      // Remove diagnosis
      diagnoses = diagnoses.filter((_, i) => i !== index);

      // Remove its sub diagnoses
      diagnosis.subDiagnoses.forEach(subDiagnosis => {
        diagnoses = diagnoses.filter((_, i) => i !== diagnoses.indexOf(subDiagnosis.name));
      });
    }

    dispatch(registrationActions.setDiagnoses(diagnoses));
  };

  const checked = (diagnosis: Diagnosis): boolean => {
    return selectedDiagnoses.includes(diagnosis.name);
  };

  return (
    <>
      {user?.requestType === RequestType.DoctorRegistration && <>
        <FormField>
          <Label required={true}>Urgence:</Label>
          <Select value={urgency ?? ''}
                  onChange={(e) => dispatch(registrationActions.setUrgency(e.target.value as Urgency))}
                  input={<Input />}>
            {urgencyOptions.map((urgency, key) =>
              <MenuItem key={key} value={urgency}>
                {urgency}
              </MenuItem>
            )}
          </Select>
        </FormField>
        <FormField>
          <Label>Pracovní diagnóza:</Label>
          {(() => {
            if (clinic?.diagnoses.length) {
              return <>
                {clinic.diagnoses.map((diagnosis, key) => {
                  return <div key={key}>
                    <FormControlLabel label={diagnosis.name}
                                      control={<Checkbox checked={checked(diagnosis)}
                                                         onChange={() => handleDiagnosisToggle(diagnosis)}
                                                         name={'diagnosis' + key} />} />
                    {checked(diagnosis) && diagnosis.subDiagnoses.length > 0 && <div className={classes.subDiagnoses}>
                      {diagnosis.subDiagnoses.map((subDiagnosis, key) =>
                        <FormControlLabel key={key}
                                          label={subDiagnosis.name}
                                          control={<Checkbox checked={checked(subDiagnosis)}
                                                             onChange={() => handleDiagnosisToggle(subDiagnosis)}
                                                             name={'subDiagnosis' + key} />} />)}
                    </div>}
                  </div>;
                })}

                <FormControlLabel label={'Jiná'}
                                  control={<Checkbox checked={showDiagnosisInput}
                                                     onChange={() => setShowDiagnosisInput(show => !show)} />} />
              </>;
            }
          })()}

          {(() => {
            if (!clinic?.diagnoses.length || showDiagnosisInput) {
              return <Input onChange={e => dispatch(registrationActions.setCustomDiagnosis(e.target.value))}
                            defaultValue={customDiagnosis}
                            placeholder='Znění diagnózy' />;
            }
          })()}
        </FormField>
      </>
      }

      <FormField>
        <Label>
          {(() => {
            if (user?.requestType === RequestType.DoctorRegistration) {
              return 'Poznámka:';
            } else {
              return 'Poznámka k budoucí návštěvě:';
            }
          })()}
        </Label>
        <Input multiline={true}
               rows={10}
               onChange={e => dispatch(registrationActions.setDescription(e.target.value))}
               defaultValue={description}
               placeholder={(() => {
                 if (user?.requestType === RequestType.DoctorRegistration) {
                   return 'Např.: stručná epikríza, důvod doporučení, požadovaný úkon, ...';
                 } else {
                   return 'Např.: Chtěl(a) bych se stát dárcem ledviny.';
                 }
               })()} />
      </FormField>
    </>
  );
};

